<script>
import TablePage from '../../../../components/table_page';

export default {
  extends: TablePage,
  components: {

  },
  data() {
    return {};
  },
  created() {
    this.getConfigList('process_log');
  },
  methods: {

  },
};
</script>
